import React from 'react';
import { makeStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: 'white',
    maxWidth: 500,
    padding: 0,

    [theme.breakpoints.down('sm')]: {
      flexGrow: 1,
    },
  },

  img: {
    marginBottom: theme.spacing(4),
  },

  paper: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(6),
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
    },

    '& > h5': {
      marginBottom: theme.spacing(4),
    },

    '& > p': {
      marginTop: theme.spacing(2),
      textAlign: 'justify',
    },
  },

  root: {
    // backgroundColor: theme.palette.background.default,
    flex: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}))

const SubmittedPage = () => {
  const classes = useStyles();

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div className={classes.root + ' has-background-light'}>
        <Hidden smDown>
          <div style={{ flex: '1 2' }}/>
        </Hidden>
        <Container className={classes.container}>
          <div className={classes.paper}>
            <div className={classes.img}>
              <img src="/alutiiq-logo-text.png" alt="Alutiiq logo" />
            </div>

            <Typography variant="h5" color="secondary">
              Thank you for registering.
            </Typography>

            <Typography variant="body1">
              When the due diligence review of your application is complete, you will receive an email notifying you that you are a prequalified subcontractor. Please note that prequalification is good for one (1) year, and subcontractors will be required to update information annually. 
            </Typography>

            <Typography variant="body1">
              We thank you for registering with Alutiiq as one of our preferred subcontractors. We look forward to working with your company in the very near future. 
            </Typography>

            <br />

            <Typography variant="body1" style={{ textAlign: 'left' }}>
              Eileen Y. Mann
              <br />
              VP Risk Management
              <br />
              <a href="mailto:emann@alutiiq.com">emann@alutiiq.com</a>
            </Typography>
          </div>
        </Container>
        <Hidden smDown>
          <div style={{ flex: '2 1' }}/>
        </Hidden>
        <div className="has-background-light is-size-7" style={{ padding: '1.5rem', textAlign: 'center' }}>
          If you have questions about this application or its processing, please contact the Alutiiq Due Diligence Team at <a href="mailto:duediligence@alutiiq.com">DueDiligence@alutiiq.com</a> | <a href="https://privacy.afognak.com/" target="_blank">Privacy Statement</a> | <a href="https://privacy.afognak.com/california-consumer-privacy-act-ccpa-notice-at-collection/" target="_blank">CCPA Collection Notice</a> 
        </div>
      </div>
    </div>
  );
}

export default SubmittedPage;
